import { useState } from "react";

const modules = [
  {
    number: "01",
    title: "Abundancia Real",
    subtitle: "Dinero sin drama",
    objective: "Cambiar el enfoque. Abundancia = sistema. Identificar fugas, evitación y hábitos que frenan ingresos.",
    videos: [
      "1.1 Abundancia real: qué es y qué no es (sin mística)",
      "1.2 Las 3 palancas de ingresos: valor + visibilidad + conversación",
      "1.3 Diagnóstico: la relación con el dinero hoy (hábitos + evitación)",
      "1.4 La regla que cambia todo: 1 decisión financiera a la semana",
    ],
    guide: "Guía 1 — Diagnóstico de Abundancia (hábitos, fugas, prioridades + 1 decisión semanal)",
    templates: [
      "Mini presupuesto (ingresos/gastos/ahorro mínimo)",
      "Checklist revisión semanal (20 min)",
    ],
    bullets: [
      "Identifica exactamente qué hábitos y decisiones están costando dinero hoy",
      "Implementa 1 decisión financiera semanal que acumula resultados en 30 días",
      "Arma el presupuesto personal en 15 minutos: sin tecnicismos, sin excusas",
    ],
    miniReto: "Completar diagnóstico + definir el 'número mínimo' (ahorro o mejora) para este mes.",
  },
  {
    number: "02",
    title: "Mapa de Valor",
    subtitle: "¿Qué se ofrece y por qué pagarían?",
    objective: "Salir del 'no sé qué hacer' y convertir habilidades en oferta clara.",
    videos: [
      "2.1 Habilidades transferibles: cómo detectarlas sin experiencia perfecta",
      "2.2 Problemas reales del mercado que se pueden resolver (lista rápida)",
      "2.3 La propuesta en 1 frase (qué hago / para quién / resultado)",
      "2.4 3 paquetes simples (Básico / Estándar / Premium) + precios orientativos",
    ],
    guide: "Guía 2 — Mapa de Valor (paso a paso + ejemplos)",
    templates: [
      "Plantilla Mapa de Valor (rellenable)",
      "Plantilla Paquetes (3 niveles)",
    ],
    bullets: [
      "Convierte lo que ya se sabe hacer en una oferta que alguien pagaría esta semana",
      "Formula la propuesta en una sola frase que genera interés inmediato",
      "Diseña 3 niveles de precio para que el cliente elija, no para tener que justificar",
    ],
    miniReto: "Escribir la oferta en 1 frase + definir 3 paquetes con precio orientativo.",
  },
  {
    number: "03",
    title: "Sistema de Oportunidades",
    subtitle: "Dejar de esperar",
    objective: "Crear un sistema semanal para generar oportunidades (sin rogar).",
    videos: [
      "3.1 Dónde están las oportunidades (empleo, freelance, colaboraciones)",
      "3.2 Sistema 10x10 (10 contactos / 10 mensajes / 10 seguimientos)",
      "3.3 Guión para pedir oportunidad sin sonar desesperado/a",
      "3.4 Seguimiento inteligente: cuándo insistir y cuándo soltar",
      "3.5 Métricas mínimas: cómo saber si se está avanzando",
    ],
    guide: "Guía 3 — Pipeline de oportunidades (registro, seguimiento, cierre)",
    templates: [
      "Pipeline (Excel/Sheets): contacto, fecha, estado, próxima acción, resultado",
      "Lista: 25 ideas para abrir oportunidades",
    ],
    bullets: [
      "Mapea en 20 minutos dónde están las próximas 5 oportunidades reales",
      "Activa el sistema 10x10: el método mínimo para nunca quedarse sin pipeline",
      "Aprende cuándo insistir y cuándo soltar sin quemar ninguna relación",
    ],
    miniReto: "Enviar 5 mensajes esta semana + registrar respuestas + próximos pasos.",
  },
  {
    number: "04",
    title: "Cobrar y Negociar",
    subtitle: "Sin vergüenza",
    objective: "Eliminar el freno más común: pedir, cobrar, negociar y sostener precio.",
    videos: [
      "4.1 Por qué cuesta cobrar (patrones reales)",
      "4.2 Cómo poner precio: mínimo viable / estándar / premium",
      "4.3 Guiones para cobrar y subir precio (copiar/pegar)",
      "4.4 Objeciones típicas y respuestas (sin conflicto)",
      "4.5 Cierre: cómo pedir respuesta (sin quedarse colgado/a)",
    ],
    guide: "Guía 4 — Banco de guiones (cobro, negociación, objeciones, cierre)",
    templates: [
      "Banco de mensajes (DM/WhatsApp/email)",
      "'Reglas de cobro' (plazos, límites, no regalar)",
    ],
    bullets: [
      "Entiende el patrón exacto que lleva a bajar el precio antes de que lo pidan",
      "Copia y pega: mensajes reales para cobrar, subir precio y cerrar sin incomodidad",
      "Responde las 5 objeciones más comunes sin ceder ni ponerse a la defensiva",
    ],
    miniReto: "Elegir 1 situación real (cobrar / pedir aumento / subir precio) y escribir el mensaje final.",
  },
  {
    number: "05",
    title: "Plan 30 días",
    subtitle: "Ejecución y continuidad",
    objective: "Convertir todo en calendario ejecutable. Salir con sistema repetible.",
    videos: [
      "5.1 Plan 30 días: semana 1–4 (qué hacer cada semana)",
      "5.2 Rutina mínima semanal (60 min): dinero + oportunidades + mejora de oferta",
      "5.3 Cómo mantener el sistema sin motivación (cuando baje la energía)",
      "5.4 Cierre: qué cambia si se sostiene 90 días (métrica de progreso)",
    ],
    guide: "Guía 5 — Calendario 30 días + checklist semanal + revisión mensual",
    templates: [
      "Calendario 30 días (con casillas)",
      "Revisión mensual (qué funcionó, qué ajusto)",
    ],
    bullets: [
      "El calendario de las próximas 4 semanas: qué hacer, cuándo y en qué orden",
      "60 minutos a la semana es todo lo que se necesita para mantener el sistema activo",
      "El método para seguir ejecutando cuando la energía baja y la motivación desaparece",
    ],
    miniReto: "Completar calendario + agendar revisión semanal (día y hora).",
  },
];

export default function CourseStructure() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleModule = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section style={{ backgroundColor: "#141414" }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-16 md:py-24">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream mb-4">
            Estructura del curso
          </h2>
          <p className="font-sans text-sm md:text-base text-cream/50 max-w-xl mx-auto">
            90–120 minutos de video · 18–20 videos · Tarea clara al final de cada uno
          </p>
        </div>

        {/* Modules — Accordion */}
        <div className="space-y-3 md:space-y-4">
          {modules.map((mod, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="rounded-lg border border-gold/20 overflow-hidden transition-all duration-300"
                style={{ backgroundColor: "#1C1C1C" }}
              >
                {/* Module header — clickable */}
                <button
                  onClick={() => toggleModule(index)}
                  className="w-full p-5 md:p-6 flex items-start gap-4 md:gap-5 text-left cursor-pointer group hover:bg-[#252525] transition-colors duration-300"
                >
                  <span
                    className="font-serif text-3xl md:text-4xl font-bold shrink-0"
                    style={{ color: "#8B7344" }}
                  >
                    {mod.number}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="font-serif text-xl md:text-2xl text-cream mb-1 group-hover:text-gold transition-colors duration-300">
                        {mod.title}
                      </h3>
                      <div className="shrink-0">
                        <i
                          className={`ri-arrow-down-s-line text-gold text-xl md:text-2xl transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                        />
                      </div>
                    </div>
                    <p className="font-sans text-sm text-gold mb-1">
                      {mod.subtitle}
                    </p>
                    <p className="font-sans text-sm text-cream/60 leading-relaxed">
                      {mod.objective}
                    </p>
                  </div>
                </button>

                {/* Module content — collapsible */}
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"}`}
                >
                  <div className="p-5 md:p-6 pt-0 space-y-5">
                    {/* Videos */}
                    <div>
                      <h4 className="font-sans text-xs font-semibold text-gold uppercase tracking-wider mb-3">
                        Videos
                      </h4>
                      <ul className="space-y-2">
                        {mod.videos.map((video, vIndex) => (
                          <li
                            key={vIndex}
                            className="flex items-start gap-3"
                          >
                            <span className="text-gold/60 text-xs mt-0.5">&#9654;</span>
                            <span className="font-sans text-sm text-cream/80 leading-relaxed">
                              {video}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Two columns: Guide/Templates | Bullets */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      {/* Left: Guide + Templates */}
                      <div className="space-y-4">
                        <div>
                          <h4 className="font-sans text-xs font-semibold text-gold uppercase tracking-wider mb-2">
                            Guía descargable
                          </h4>
                          <p className="font-sans text-sm text-cream/80 leading-relaxed">
                            {mod.guide}
                          </p>
                        </div>
                        <div>
                          <h4 className="font-sans text-xs font-semibold text-gold uppercase tracking-wider mb-2">
                            Plantillas
                          </h4>
                          <ul className="space-y-1.5">
                            {mod.templates.map((tpl, tIndex) => (
                              <li
                                key={tIndex}
                                className="flex items-start gap-2"
                              >
                                <span className="text-gold text-xs mt-0.5">&#10022;</span>
                                <span className="font-sans text-sm text-cream/70">
                                  {tpl}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      {/* Right: Bullets */}
                      <div>
                        <h4 className="font-sans text-xs font-semibold text-gold uppercase tracking-wider mb-3">
                          Resultados del módulo
                        </h4>
                        <ul className="space-y-2.5">
                          {mod.bullets.map((bullet, bIndex) => (
                            <li
                              key={bIndex}
                              className="flex items-start gap-2"
                            >
                              <span className="w-1 h-1 rounded-full bg-gold mt-2 shrink-0" />
                              <span className="font-sans text-sm text-cream/80 leading-relaxed">
                                {bullet}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Mini reto */}
                    <div
                      className="rounded-md p-4 border border-gold/20"
                      style={{ backgroundColor: "#0D0D0D" }}
                    >
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center border border-gold/40 shrink-0 mt-0.5">
                          <i className="ri-flashlight-line text-gold text-sm" />
                        </div>
                        <div>
                          <h4 className="font-sans text-xs font-semibold text-gold uppercase tracking-wider mb-1">
                            Mini-reto
                          </h4>
                          <p className="font-sans text-sm text-cream/80 leading-relaxed">
                            {mod.miniReto}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Divider */}
      <div className="h-px bg-gold-gradient" />
    </section>
  );
}